import { render } from "./AdminCompanyDeleteDialog.vue?vue&type=template&id=52a8f730&scoped=true"
import script from "./AdminCompanyDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AdminCompanyDeleteDialog.vue?vue&type=script&lang=js"

import "./AdminCompanyDeleteDialog.vue?vue&type=style&index=0&id=52a8f730&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a8f730"]])

export default __exports__